import { render, staticRenderFns } from "./BaseInputV2.vue?vue&type=template&id=afb25752&scoped=true"
import script from "./BaseInputV2.vue?vue&type=script&lang=js"
export * from "./BaseInputV2.vue?vue&type=script&lang=js"
import style0 from "./BaseInputV2.vue?vue&type=style&index=0&id=afb25752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb25752",
  null
  
)

export default component.exports